import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

// Shards-React Components
import { Row, Col, Container } from "shards-react"

const TermsOfUsePage = props => (
  <Layout countryCode={props.pageContext.countryCode || "JM"}>
    <SEO
      title="Terms of Use"
      description="Terms of Use effective January 1, 2020."
      countryCode={props.pageContext.countryCode || "JM"}
    />

    <Container>
      <br />
      <h3>Terms of Use</h3>

      <br />
    </Container>
  </Layout>
)

export default TermsOfUsePage
